// antd
import Row from 'antd/lib/row'
//import Col from 'antd/lib/col'
import Flex from 'antd/lib/flex'
import Divider from 'antd/lib/divider'
import Card from 'antd/lib/card'
import Button from 'antd/lib/button'
import {FacebookOutlined,InstagramOutlined,WhatsAppOutlined} from '@ant-design/icons'

//import TE from '../../assets/TE_SQ2.svg'

const Footer = () => {
    return <Flex vertical align='center' >
        <Flex>
            <Card className='m-2 d-flex align-items-center border border-0'>
                <h1 className='text-start fs-5'>Telefono</h1>
                <a className='text-start fs-5' href='tel:+50584905650'>+(505) 8490 5650</a>
            </Card>
            <Card title="Redes Sociales" className='m-2 border border-0'>
                <Button icon={<FacebookOutlined />} shape='circle' size='large' className='m-2 bg-c1 text-white' type="primary" target='_blank' href='https://www.facebook.com/share/1L9zMGtXfc/?mibextid=wwXIfr'/>
                <Button icon={<InstagramOutlined />} shape='circle' size='large' className='m-2 bg-c4 text-white' type="danger" target='_blank' href='https://www.instagram.com/tuanis_express/'/>
                <Button icon={<WhatsAppOutlined />} shape='circle' size='large' className='m-2 bg-c3 text-white' type="success" target="_blank" href="https://wa.me/50584905650?text=Hola, quero saber hacer mi pedido, vengo de la web de Tuani's Express."/>
            </Card>
        </Flex>
        <Divider className='c2 bg-c2'/>
        <Row>
            <h1 className='text-ms-c5 text-center fs-5'>Copyright © 2025 Tuanis Express - Todos los derechos reservados.</h1>
        </Row>
    </Flex>
}

export default Footer